<template>
  <div class="side-user-form">
    <div class="top-bar up-top-bar">
      <div class="up-top-links">
        <div class="up-top-link">
          <a @click.prevent="$emit('close')">
            <img src=".././assets/images/deactivate_white.svg" alt="">&nbsp;Cancel
          </a>
        </div>
        <div class="up-top-link ml-auto">
          <a @click.prevent="store">Save</a>
        </div>
      </div>
    </div>
    <div class="top-bar-menu">
      <router-link to="/access-logs">Access Logs</router-link>
      <router-link to="/events">Log view</router-link>
    </div>
    <profile-component :user="user" page="AddUserProfile" @update="updatePhoto"></profile-component>
  </div>
</template>

<script>
  import ProfileComponent from '@/components/ProfileComponent';

  export default {
    name: 'UserProfile',
    components: {
      ProfileComponent
    },
    data() {
      return {
        user: {
          default: {
            first_name: '',
            last_name: '',
            mail: '',
            type: '',
            key: ''
          }
        },
        photo: null
      };
    },
    computed: {
      roles() {
        return this.$store.state.settings.data.user_types;
      }
    },
    methods: {
      store() {
        if (this.user.key != this.user.confirm_key) {
          this.$snotify.error('The two passwords do not match');

          return;
        }

        const data = {
          user_id: this.user.id,
          fields: ["first_name", "last_name", "mail", "key" /* = password*/, "type"],
          values: [this.user.first_name, this.user.last_name, this.user.mail, this.user.key, this.user.type]
        };

        this.$store.dispatch('users/addUser', data)
          .then((response) => {
            this.user.id = response.data.user.id;

            if (this.photo) {
              this.updateUserPhotoAndRedirect();

              return;
            }

            this.$emit('saved');
          })
          .catch((error) => this.$snotify.error(error.response.data.message));
      },
      updatePhoto(photo) {
        this.photo = photo;
      },
      updateUserPhotoAndRedirect() {
        this.$store.dispatch('users/updatePhoto', { user_id: this.user.id, photo: this.photo })
          .then(() => {
            this.$snotify.success('User added successfully');
            this.$emit('saved');
          })
          .catch((error) => this.$snotify.error(error.response.data.message));
      }
    }
  };
</script>
